import React from "react";
import { LayoutTemplate } from "../LayoutTemplate";
import * as S from "./styles";
import { Button } from "../../Atoms/Button";
import { useMediaQuery } from "react-responsive";
import CookieBannerPage from "../../Atoms/CookieBanner";
import { formatarTelefoneMascara, openWhatsApp } from "../../../utils/whatsapp";

const imperatriz_whatsapp = "99984448605";
const sao_luis_whatsapp = "98984325410";

export const HomeTemplate = () => {
  const isMobile = useMediaQuery({ maxWidth: "500px" });

  function handleScheduling() {
    window.open("agendamento", "_self");
  }

  return (
    <LayoutTemplate>
      <CookieBannerPage />
      <S.Container>
        <S.Main id="sobre">
          <S.Title>
            <img src="/assets/imgs/group-title.svg" alt="img context" />
            Velox vistorias
          </S.Title>
          {isMobile ? (
            <S.Text>
              Somos uma empresa dedicada a fornecer serviços de{" "}
              <S.Strong>vistorias automotivas precisas</S.Strong> e{" "}
              <S.Strong>confiáveis</S.Strong>, com uma{" "}
              <S.Strong>equipe experiente</S.Strong> e altamente{" "}
              <S.Strong>qualificada</S.Strong>.
            </S.Text>
          ) : (
            <S.Text>
              Somos uma empresa dedicada a fornecer serviços de{" "}
              <S.Strong>vistorias automotivas precisas</S.Strong> e{" "}
              <S.Strong>confiáveis</S.Strong>, com uma{" "}
              <S.Strong>equipe experiente</S.Strong> e altamente{" "}
              <S.Strong>qualificada</S.Strong>. Nos destacamos pelo compromisso
              com a segurança dos nossos clientes.
            </S.Text>
          )}
          <Button onClick={handleScheduling}>AGENDE SUA VISTORIA</Button>
        </S.Main>
        <S.SectionService id="servicos">
          <S.ServiceContent>
            <h2 className="flex justify-center">
              <img src="/assets/imgs/group-dark.svg" alt="icone group" />
              SERVIÇOS
            </h2>
            <p>
              <S.Strong>Compre</S.Strong> e <S.Strong>agende online</S.Strong>{" "}
              sua vistoria conosco.
            </p>

            <S.ServiceInfos>
              <h2>Vistoria de Transferência / 1° EMPLACAMENTO Posto fixo</h2>
              <S.Wrapper>
                <div>
                  <h4>R$ 152{/* <span>**</span> */}</h4>
                </div>
              </S.Wrapper>

              <h2>Vistoria de Transferência / 1° EMPLACAMENTO Domicilar</h2>
              <S.Wrapper>
                <div>
                  <h4>R$ 190 {/* <span>**</span> */}</h4>
                </div>
              </S.Wrapper>

              {/* <S.Info>
                <p>
                  <span className="strong">*</span>
                  Ônibus <span>/</span> Micro-ônibus <span>/</span> Reboque{" "}
                  <span>/</span> Semirreboque <span>/</span> Caminhão{" "}
                  <span>/</span> Caminhão Trator <span>/</span> Trator de Rodas{" "}
                  <span>/</span> Trator Misto <span>/</span> Chassi{" "}
                  <span>/</span> Plataforma
                </p>
              </S.Info> */}
              {/* <S.Info>
                <p>
                  <span className="strong">**</span>
                  Taxa será acrescida no valor da compra. Taxa bancária no{" "}
                  <span>Boleto</span> no valor de <span>R$ 3,92</span>.
                </p>
              </S.Info> */}

              <Button data-variant-dark onClick={handleScheduling}>
                AGENDE SUA VISTORIA
              </Button>
            </S.ServiceInfos>
          </S.ServiceContent>
        </S.SectionService>
        <S.SectionLocalization id="localizacao">
          <S.LocalizationContent>
            <h2 className="flex justify-center">
              <img src="/assets/imgs/group.svg" alt="" />
              Localização
            </h2>
            <S.WrapperMap>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3396.411494882706!2d-44.253834950778966!3d-2.5536903171924106!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7f683006a8afa37%3A0x32535f240883d0ea!2sVelox%20Vistorias%20Veiculares!5e0!3m2!1spt-BR!2sbr!4v1777036159302!5m2!1spt-BR!2sbr" 
                width="600" 
                height="450" 
                style={{border:'0'}} 
                allowFullScreen={true} 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"></iframe>
              <h5>
                <img src="/assets/imgs/pin.svg" alt="pin mapa" />
                SÃO LUÍS/ MA
              </h5>
            </S.WrapperMap>
            <S.WrapperMap>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d63542.5396728451!2d-47.5293524!3d-5.5061783!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92cf8bad96492407%3A0x290ed27bbb04f5d8!2sVelox%20Vistorias%20Imperatriz!5e0!3m2!1spt-BR!2sbr!4v1777036762224!5m2!1spt-BR!2sbr" 
                width="600" 
                height="450" 
                style={{border:'0'}} 
                allowFullScreen={true} 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"></iframe>
              <h5>
                <img src="/assets/imgs/pin.svg" alt="pin mapa" />
                imperatriz/ MA
              </h5>
            </S.WrapperMap>
            <S.WrapperMap>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.718203588539!2d-47.4409219!3d-6.557213599999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92d0a176d9cd0931%3A0x1f45c866c790b3e4!2sVelox%20Vistorias%20-%20Estreito!5e0!3m2!1spt-BR!2sbr!4v1777036973622!5m2!1spt-BR!2sbr" 
                width="600" 
                height="450" 
                style={{border:'0'}} 
                allowFullScreen={true} 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"></iframe>
              <h5>
                <img src="/assets/imgs/pin.svg" alt="pin mapa" />
                estreito/ MA
              </h5>
            </S.WrapperMap>
            <S.WrapperMap>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d508202.43900535424!2d-47.1285912!3d-5.6651038!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92d21f003a388eab%3A0x818b876dbbf41b24!2sVelox%20Vistorias%20Veiculares!5e0!3m2!1spt-BR!2sbr!4v1777037201882!5m2!1spt-BR!2sbr" 
                width="600" 
                height="450" 
                style={{border:'0'}} 
                allowFullScreen={true} 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"></iframe>
              <h5>
                <img src="/assets/imgs/pin.svg" alt="pin mapa" />
                grajaú/ MA
              </h5>
            </S.WrapperMap>
            <S.WrapperMap>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3977.1142811133273!2d-44.593531399999996!3d-4.5734853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x78a272083c28ca5%3A0x7477bda5cbfb66f3!2sVelox%20Vistorias!5e0!3m2!1spt-BR!2sbr!4v1777037277172!5m2!1spt-BR!2sbr" 
                width="600" 
                height="450" 
                style={{border:'0'}} 
                allowFullScreen={true} 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"></iframe>
              <h5>
                <img src="/assets/imgs/pin.svg" alt="pin mapa" />
                pedreiras/ MA
              </h5>
            </S.WrapperMap>
          </S.LocalizationContent>
        </S.SectionLocalization>
        <hr />
        <S.SectionContact id="contato">
          <S.ContactContent>
            <h2 className="flex justify-center">
              <img src="/assets/imgs/group.svg" alt="icone group" />
              Contato
            </h2>

            <S.WrapperContacts>
              <S.Contact>
                <S.ContactText>
                  <p>são luís / MA</p>
                </S.ContactText>

                <h3>
                  <button
                    className="flex gap-2 items-center"
                    onClick={() => openWhatsApp(sao_luis_whatsapp)}
                  >
                    <img
                      src="/assets/imgs/icon-whatsapp.svg"
                      alt="icone whatsapp"
                      className="w-8 h-8"
                    />
                    <span>{formatarTelefoneMascara(sao_luis_whatsapp)}</span>
                  </button>
                </h3>
              </S.Contact>
              <S.Contact>
                <S.ContactText>
                  <p>imperatriz/ MA</p>
                  <p>grajaú / MA</p>
                  <p>estreito / MA</p>
                  <p>pedreiras / MA</p>
                </S.ContactText>
                <h3>
                  <button
                    className="flex gap-2 items-center"
                    onClick={() => openWhatsApp(imperatriz_whatsapp)}
                  >
                    <img
                      src="/assets/imgs/icon-whatsapp.svg"
                      alt="icone whatsapp"
                      className="w-8 h-8"
                    />
                    <span>{formatarTelefoneMascara(imperatriz_whatsapp)}</span>
                  </button>
                </h3>
              </S.Contact>
            </S.WrapperContacts>
          </S.ContactContent>
        </S.SectionContact>
      </S.Container>
    </LayoutTemplate>
  );
};
